<template >
    <div class="leftPanelContainer">
        <slot name="content">content</slot>
    </div>
</template>
<script>
export default {
    name: 'leftPanel'
}
</script>